<template>
<b-overlay :show="show" rounded="sm">
  <b-container fluid class="bg-white">
    <b-row><b-col>&nbsp;</b-col></b-row>
    <b-row class="mb-3">
      <b-col>
        <h3 tabindex="0">{{acao === 'visualizar' ? 'Visualizar Configuração da Conferência' : 'Configurar Conferência'}}</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="2">&nbsp;</b-col>
      <b-col sm="8">
        <b-row>
          <b-col sm="_">
            <b-row align-h="end">
              <b-button pill variant="primary">1</b-button>
            </b-row>
          </b-col>
          <b-col><hr/></b-col>
          <b-col sm="_">
            <b-row align-h="center">
              <b-button pill variant="outline-secondary">2</b-button>
            </b-row>
          </b-col>
          <b-col><hr/></b-col>
          <b-col sm="_">
            <b-row align-h="center">
              <b-button pill variant="outline-secondary">3</b-button>
            </b-row>
          </b-col>
          <b-col><hr/></b-col>
          <b-col sm="_">
            <b-row align-h="start">
              <b-button pill variant="outline-secondary">4</b-button>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-4">
      <b-col sm="12">
        <b-row>
          <b-col tabindex="0" sm="3">
            <b-row align-h="around">Dados da Conferência</b-row>
          </b-col>
          <b-col tabindex="0" sm="3">
            <b-row align-h="around">Datas da Conferência</b-row>
          </b-col>
          <b-col tabindex="0" sm="3">
            <b-row align-h="around">Pós-Conferência</b-row>
          </b-col>
          <b-col tabindex="0" sm="2">
            <b-row align-h="center">Texto Apresentação</b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-form @submit.stop.prevent="salvar">
      <b-row class="mb-2">
        <b-col sm="8">
          <b-form-group tabindex="0" label="Nome da Conferência: *" for="nome">
            <b-form-input id="nome" v-model="nome" required disabled/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group tabindex="0" label="Sigla: *" for="sigla">
            <b-form-input id="sigla" v-model="sigla" required disabled/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col sm="8">
          <b-form-group tabindex="0" label="Banner da Conferência: * (.jpg, .jpeg ou .png)" for="banner">
            <table style="width:100%" v-if="bannerSalvo">
              <tr>
                <td tabindex="0">{{bannerSalvo}}</td>
                <td tabindex="0"><b-form-file id="banner" ref="banner" v-model="banner" placeholder="Escolha um arquivo..." accept="image/jpeg, image/png" browse-text="Selecionar" :disabled="acao === 'visualizar'"/></td>
              </tr>
            </table>
            <b-form-file id="banner" ref="banner" v-model="banner" placeholder="Escolha um arquivo..." accept="image/jpeg, image/png" browse-text="Selecionar" required v-else/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group tabindex="0" label="Conferência pública? *" for="publica">
            <b-form-radio-group id="publica" v-model="publica" :options="simNao" required :disabled="acao === 'visualizar'"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col sm="12">
          <b-form-group tabindex="0" label="Descrição da Conferência:" for="descricao">
            <b-form-textarea id="descricao" v-model.trim="descricao" no-resize rows="3" :disabled="acao === 'visualizar'"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-row no-gutters>
            <b-button @click="voltar">
              <i class="fa fa-arrow-left"/>&nbsp;&nbsp;Voltar
            </b-button>
          </b-row>
        </b-col>
        <b-col sm="6">
          <b-row no-gutters align-h="end">
            <b-button type="submit" variant="primary">
              <i class="fa fa-floppy-o"/>&nbsp;&nbsp;{{acao === 'visualizar' ? 'Avançar' : 'Salvar e Avançar'}}
            </b-button>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
    <b-row>
      <b-col>&nbsp;</b-col>
    </b-row>
  </b-container>
</b-overlay>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import SessionStorage from '@/services/session-storage'

export default {
  data () {
    return {
      acao: this.$route.params.acao,
      id: null,
      nome: null,
      sigla: null,
      bannerSalvo: null,
      banner: null,
      publica: null,
      descricao: null,
      publicaAnterior: null,
      descricaoAnterior: null,
      show: false,
      simNao: [
        {value: true, text: 'Sim'},
        {value: false, text: 'Não'}
      ]
    }
  },
  computed: {
    ...mapState({
      conferencia: state => state.conferencia.conferencia,
      configurarConferencia: state => state.conferencia.configurarConferencia
    })
  },
  mounted () {
    this.$store.dispatch('setConferencia', {
      'conferencia_id': SessionStorage.get('conferencia_atual_id'),
      'conferencia_nome': SessionStorage.get('conferencia_atual_nome')
    })

    this.nome = SessionStorage.get('conferencia_atual_nome')    
    this.sigla = SessionStorage.get('conferencia_atual_sigla') !== 'null' ? SessionStorage.get('conferencia_atual_sigla') : ''

    Vue.http.post('api/configurarConferencia/buscar', {conferencia_id: SessionStorage.get('conferencia_atual_id')}).then(response => {
      if (response.body.success && response.body.data.length > 0) {
        this.$store.dispatch('setConfigurarConferencia', response.body.data[0])
      }else{
        this.$store.dispatch('setConfigurarConferencia', {})
      }
      
      if (this.configurarConferencia.situacao && this.acao === 'cadastrar') {
        this.navigate('/configurarConferencia/gerenciar')
      } else {     
        this.id = this.configurarConferencia.id ? this.configurarConferencia.id : null
        this.bannerSalvo = this.configurarConferencia.banner
        this.publica = this.configurarConferencia.publica
        this.publicaAnterior = this.configurarConferencia.publica
        if (this.configurarConferencia.descricao) {
          this.descricao = this.configurarConferencia.descricao
          this.descricaoAnterior = this.configurarConferencia.descricao
        }

      }
    })
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    },
    sucesso (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Sucesso',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'info'
      })
    },
    erro (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Erro',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'danger'
      })
    },
    voltar () {
      if (this.acao === 'cadastrar') {
        if (this.banner || this.publica || this.descricao) {
          this.$bvModal.msgBoxConfirm('Tem certeza que deseja voltar? As informações inseridas serão perdidas.', {
            noCloseOnBackdrop: true,
            centered: true,
            okTitle: 'Confirmar',
            cancelTitle: 'Cancelar'
          }).then(valor => {
            if (valor) {
              this.navigate('/')
            }
          })
        } else {
          this.navigate('/')
        }
      } else {
        if (this.banner || this.publica !== this.publicaAnterior || this.descricao !== this.descricaoAnterior) {
          this.$bvModal.msgBoxConfirm('Tem certeza que deseja voltar? As informações inseridas serão perdidas.', {
            noCloseOnBackdrop: true,
            centered: true,
            okTitle: 'Confirmar',
            cancelTitle: 'Cancelar'
          }).then(valor => {
            if (valor) {
              this.navigate('/configurarConferencia/gerenciar')
            }
          })
        } else {
          this.navigate('/configurarConferencia/gerenciar')
        }
      }
    },
    salvar () {
      if (this.descricao && this.descricao.length > 4096) {
        this.erro('Texto do campo Descrição não deve ultrapassar 4.096 caracteres!')
        return
      }

      if (this.acao === 'visualizar') {
        this.navigate('/configurarConferencia/passo2/' + this.acao)
        return
      }

      let dados = new FormData()

      dados.append('id', this.id)
      dados.append('conferencia_id', this.conferencia.conferencia_id)
      if (this.banner) {
        dados.append('banner', this.banner)
      }
      dados.append('publica', this.publica)
      if (this.descricao) {
        dados.append('descricao', this.descricao)
      }
      this.show = true
      Vue.http.post('api/configurarConferencia/salvar1', dados).then(response => {
        this.show = false
        if (response.body.success) {
          this.$store.commit('setMensagemConferencia', 'Dados salvos com sucesso!')
          this.navigate('/configurarConferencia/passo2/' + this.acao)
        }        
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/conferencia/Passo1.vue